<template>
  <Loading v-if="isLoading" />
  <div class="sort-group ty01">
    <div class="sort-row">
      <div class="wl">
        <div class="date-sort">
          <c-inputSearch v-bind="inputSearch" v-model="searchModel" @search-word="onClickSearch" />
          <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
          <div class="txt02">~</div>
          <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
        </div>
        <div class="date-sort">
          <c-btn02 :btnText="t('message.oneWeek')" class="ty01" @click="onClickDate('week')"/>
          <c-btn02 :btnText="t('message.oneMonth')" class="ty01" @click="onClickDate('month')"/>
        </div>
      </div>
    </div>
    <div class="sort-row">
      <div class="wl">
        <Select v-bind="deptSelect" v-model="deptModel"/>
        <Select v-bind="posSelect" v-model="posModel"/>
        <Select v-bind="shiftSelect" v-model="shiftModel"/>
        <Select v-bind="monitoringSelect" v-model="monitoringModel"/>
        <Select v-bind="excludeSelect" v-model="excludeModel"/>
      </div>
    </div>
  </div>
  <div class="scrollbar">
    <div class="tbl-group size-custom18">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page-options="footerOptions"
        return-object
      >
        <template v-slot:item.isExclude="{ item }" >
          <div class="check-group ty03">
            <v-checkbox :model-value="item.isExclude"
                        @click="onChangeCheck(item.idx, $event)"
                        true-value="Y" false-value="N"
            >
            </v-checkbox>
          </div>
        </template>
        <template v-slot:item.situation="{ item }" >
          <div class="tal">
            {{item.situation}}
          </div>
        </template>
        <template v-slot:item.memberInfo="{ item }" >
          <div class="txt-tag">
            {{item.memberName+'('+item.memberId+')'+item.deptName+'/'+item.posName}}
          </div>
        </template>
        <template v-slot:item.targetInfo="{ item }" >
          <div class="txt-tag">
            {{utils.isEmpty(item.targetMemberName)?'':item.targetMemberName+'/'+item.targetDeptName}}
          </div>
        </template>
        <template v-slot:item.regDateFormat="{ item }" >
          <div class="tal">
            {{dayjs(item.regDate).format('YYYY-MM-DD HH:mm:ss')}}
          </div>
        </template>
        <template v-slot:item.detailView="{ item }">
          <div class="flex-c">
            <BtnIcon class="btn-ico-search" @click="onClickDetail(item, '3')"/>
          </div>
        </template>
      </v-data-table>
    </div>
    <v-divider class="mb-4"></v-divider>
  </div>
  <DialogMonitoringDetail
    v-model="detailDialogModel"
    @close="detailDialogModel=false"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from 'vue';
import BbsService from "@/services/bbs.service";
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const isLoading = ref(false)
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
const detailDialogModel = ref(false)
const deptSelect = ref({items: [{name:t('message.department'), value:''}]})
const posSelect = ref({items: [{name:t('message.position'), value:''}]})
const shiftSelect = ref({items: [{name: t('message.shiftWork'), value: ''}]})
const monitoringSelect = ref({items: [{name:t('message.monitoringAll'), value:''}]})
const excludeSelect = ref({items: [{name:t('message.statistics'), value:''}, {name:t('message.excludeFromStatistics'), value:'Y'},{name:t('message.includeInStatistics'), value:'N'}]})
const startDate = ref('')
const endDate = ref('')
const deptModel = ref('')
const posModel = ref('')
const shiftModel = ref('')
const monitoringModel = ref('')
const excludeModel = ref('')
const searchModel = ref(null)
const headers = ref([
  { title: t('message.excludeFromStatistics'), key: 'isExclude' },
  { title: t('message.category'), key: 'situation' },
  { title: t('message.author'), key: 'memberInfo'},
  { title: t('message.correctiveActionTarget'), key: 'targetInfo' },
  { title: t('message.createdAt'), key: 'regDateFormat' },
  { title: t('message.viewDetails'), key: 'detailView' },
])
const items = ref([])

//ui
const inputSearch = {
  type: 'text',
  placeholder: t('message.searchMultiPlaceholder'),
}

const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
onMounted(() => {
  onClickDate('week')
})

const onClickSearch=()=>{
  isLoading.value = true
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    keyword: searchModel.value,
    startDate:startDate.value,
    endDate:endDate.value,
    companyIdx:localStorage.getItem('companyIdx'),
    isExclude:excludeModel.value,
    monitoringIdx:monitoringModel.value,
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    excludeType:'2',  //타입 1:모니터링 2:안전대화
    isTemp:'N'
  }

  items.value = []
  TimelineService.getTimelineList(params).then(
    (response) => {
      isLoading.value = false
      //타임라인
      items.value = response.result
      _.forEach(items.value, (val, key)=> {
        val.typeText = val.type=='1'?t('message.correctiveSafetyTalk'):t('message.supportiveSafetyTalk')
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.target = val.targetDept
        else if(val.targetType == '3') val.target = val.targetMember
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })
    },
    (error) => {
      isLoading.value = false
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickDate=(type)=>{
  const end = dayjs().format('YYYY-MM-DD')
  let start = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  if(type == 'month')
    start = dayjs().subtract(1, 'month').format('YYYY-MM-DD')

  startDate.value = start.toString()
  endDate.value = end.toString()
}

const onChangeCheck=(idx, event)=>{
  let user = JSON.parse(localStorage.getItem('user'))
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    excludeType:'2',
    idx:idx,
    isExclude:event.target.checked?'Y':'N',
    companyIdx:companyIdx
  }

  TimelineService.updateTimelineExclude(params).then(
    (response) => {
      if(response.success){
        if(params.isExclude=='Y')
          snackText.value = '제외 되었습니다.'
        else
          snackText.value = '복구 되었습니다.'
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickDetail=(item, type)=>{
  storeRef.popupIdx.value = item.idx
  storeRef.popupType.value = type
  storeRef.viewIdx.value = item.monitoringIdx
  detailDialogModel.value=true
}

//watch
watch(startDate, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(endDate, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(deptModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(posModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(shiftModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(monitoringModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(excludeModel, (newObj) => {
  if(props.isActive)
    onClickSearch()
})

watch(() => props.isActive, (val, oldVal) => {
  if (val) {
    //본인부서에 해당하는 모니터링, 부서, 맴버정보
    const companyIdx = localStorage.getItem('companyIdx')
    let params2 = {companyIdx: companyIdx, actionType:'1', isAll:'Y'}
    BbsService.getMonitoringFilter(params2).then(
      (response) => {
        //모니터링{{t('message.filter')}}
        let monitoringList = response.result.monitoringList
        monitoringSelect.value = {items: [{name:t('message.monitoringAll'), value:''}]}
        _.forEach(monitoringList, (item)=> {
          monitoringSelect.value.items.push({name: item.monitoringTitle, value: item.idx})
          if (viewIdx == item.idx)
            monitoringModel.value = item.idx
        })
        //부서{{t('message.filter')}}
        let deptList = response.result.deptList
        deptSelect.value = {items: [{name:t('message.department'), value:''}]}
        _.forEach(deptList, (item)=> {
          deptSelect.value.items.push({name: item.treeName, value: item.idx})
        })
        //직책{{t('message.filter')}}
        let posList = response.result.posList
        posSelect.value = {items: [{name:t('message.position'), value:''}]}
        _.forEach(posList, (item)=> {
          posSelect.value.items.push({name: item.treeName, value: item.idx})
        })
        //교대조
        let shiftList = response.result.shiftList
        shiftSelect.value = {items: [{name:t('message.shiftWork'), value:''}]}
        _.forEach(shiftList, (item)=> {
          shiftSelect.value.items.push({name: item.shiftName, value: item.idx})
        })
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
    onClickSearch()
  }
},{ immediate: true })
</script>


<style lang="scss">
</style>
